import './Privacy.css';

export default function Privacy() {
  return (
    <div className="Privacy">
      <h1>Privacy Policy</h1>

      <p>Your privacy is important to us. It is Stardew Save Editor's policy to respect your privacy and comply with any applicable laws and regulations regarding any personal information we may collect from you, including across our website, https://stardewsaveeditor.com, and other services we own and operate.</p>

      <p>This policy is effective as of 3 January 2020 and was last updated on 8 September 2022.</p>


      <h3>Information We Collect</h3>

      <p>Information we collect includes information automatically sent by your devices in the course of accessing our applications.</p>


      <h3>Log Data</h3>

      <p>Our app uses AppCenter for crash reporting and analytics, so when you use our application, anonymized data may be sent about which features of the app you use.</p>

      <p>Data collected may include the screens you visit, the time and date of your visit, the time spent on each page, and technical details that occur in conjunction with any errors you may encounter.</p>

      <p>Please be aware that while this information may not be personally identifying by itself, it may be possible to combine it with other data to personally identify individual persons.</p>


      <h3>Personal Information</h3>

      <p>Other than crash reports which may include device hardware and software versions, no personally identifying information is collected.</p>


      <h3>Collection and Use of Information</h3>

      <p>We may collect personal information from you when you do any of the following on our website:</p>

      <ul>
        <li>Use a mobile device or web browser to access our content</li>
        <li>Contact us via email, social media, or on any similar technologies</li>
        <li>When you mention us on social media</li>
      </ul>

      <p>We may collect, hold, use, and disclose information for the following purposes, and personal information will not be further processed in a manner that is incompatible with these purposes:</p>

      <ul>
        <li>for analytics, market research, and business development, including to operate and improve our website, associated applications, and associated social media platforms</li>
        <li>for security and fraud prevention, and to ensure that our sites and apps are safe, secure, and used in line with our terms of use</li>
      </ul>

      <p>Please be aware that we may combine information we collect about you with general information or research data we receive from other trusted sources.</p>


      <h3>Children’s Privacy</h3>

      <p>We do not aim any of our products or services directly at children under the age of 13, and we do not knowingly collect personal information about children under 13.</p>


      <h3>International Transfers of Personal Information</h3>

      <p>The personal information we collect is stored and/or processed where we or our partners, affiliates, and third-party providers maintain facilities. Please be aware that the locations to which we store, process, or transfer your personal information may not have the same data protection laws as the country in which you initially provided the information. If we transfer your personal information to third parties in other countries: (i) we will perform those transfers in accordance with the requirements of applicable law; and (ii) we will protect the transferred personal information in accordance with this privacy policy.</p>


      <h3>Your Rights and Controlling Your Personal Information</h3>

      <p>You always retain the right to withhold personal information from us, with the understanding that your experience of our website may be affected. We will not discriminate against you for exercising any of your rights over your personal information. If you do provide us with personal information you understand that we will collect, hold, use and disclose it in accordance with this privacy policy. You retain the right to request details of any personal information we hold about you.</p>


      <p>If we receive personal information about you from a third party, we will protect it as set out in this privacy policy. If you are a third party providing personal information about somebody else, you represent and warrant that you have such person’s consent to provide the personal information to us.</p>


      <p>If you have previously agreed to us using your personal information for direct marketing purposes, you may change your mind at any time. We will provide you with the ability to unsubscribe from our email-database or opt out of communications. Please be aware we may need to request specific information from you to help us confirm your identity.</p>


      <p>If you believe that any information we hold about you is inaccurate, out of date, incomplete, irrelevant, or misleading, please contact us using the details provided in this privacy policy. We will take reasonable steps to correct any information found to be inaccurate, incomplete, misleading, or out of date.</p>


      <p>If you believe that we have breached a relevant data protection law and wish to make a complaint, please contact us using the details below and provide us with full details of the alleged breach. We will promptly investigate your complaint and respond to you, in writing, setting out the outcome of our investigation and the steps we will take to deal with your complaint. You also have the right to contact a regulatory body or data protection authority in relation to your complaint.</p>


      <h3>Limits of Our Policy</h3>

      <p>Our website may link to external sites that are not operated by us. Please be aware that we have no control over the content and policies of those sites, and cannot accept responsibility or liability for their respective privacy practices.</p>


      <h3>Changes to This Policy</h3>

      <p>At our discretion, we may change our privacy policy to reflect updates to our business processes, current acceptable practices, or legislative or regulatory changes. If we decide to change this privacy policy, we will post the changes here at the same link by which you are accessing this privacy policy.</p>

      <p>If required by law, we will get your permission or give you the opportunity to opt in to or opt out of, as applicable, any new uses of your personal information.</p>


      <h3>Contact Us</h3>

      <p>For any questions or concerns regarding your privacy, you may contact us using the following details:</p>

      <p>Chad Smith<br/>
      chad@developer.email</p>
    </div>
  );
}